var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconContentWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.68 23.25H1.82a1.07 1.07 0 0 1-1.07-1.08V1.83A1.07 1.07 0 0 1 1.82.75h15.1A1.08 1.08 0 0 1 18 1.83v5.38M7.2 6.38h6.46",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 6a.38.38 0 1 1 0 .75.38.38 0 0 1 0-.75m0 3.86a.38.38 0 1 1 0 .75.38.38 0 0 1 0-.75m12.13 1.49a11.92 11.92 0 0 0-1.69-.9 2.09 2.09 0 0 0-2.13.17l-1.85 1.32a2.59 2.59 0 0 0-1.06 1.75l-.28 2m14.33 6.81-5.36-8.56",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13.71 16.5 5.57-3.41a1.62 1.62 0 0 0-1.69-2.76L7.5 16.52l-1.91 3.06 3.59-.31L11.25 18",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5h-3.75a1.5 1.5 0 0 0-1.5 1.5 1.5 1.5 0 0 0 1.5 1.5h2.74l1.76 3.75",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconContentWrite);
export default __webpack_public_path__ + "static/media/streamline-icon-content-write.d7202f2b.svg";
export { ForwardRef as ReactComponent };